import React, { Component } from 'react';

export default class Loading extends Component {
  static propTypes = {};

  render() {
    const width = this.props.width ? this.props.width : '40px';
    const height = this.props.height ? this.props.height : '40px';
    return (
      <div className="common-loading loading" style={this.props.style || {}}>
        <svg
          className="spinner"
          width={width}
          height={height}
          viewBox="0 0 66 66"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            className="path"
            fill="none"
            strokeWidth="3"
            strokeLinecap="round"
            cx="33"
            cy="33"
            r="30"
          ></circle>
        </svg>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/common/Loading.js